import styled from 'styled-components';

export const SubNavWrapper = styled.div`
  max-width: 92%;
  margin: 0 auto;
  display: flex;
  border-bottom: 1px solid #adadad;
`;

export const SubNavButtonActive = styled.div`
  padding: 1rem;
  font-weight: 600;
  color: rgb(75, 40, 109);
  border-bottom: 2px solid rgb(75, 40, 109);
  cursor: pointer;
`;

export const SubNavButton = styled.div`
  padding: 1rem;
  font-weight: 500;
  cursor: pointer;
  color: rgb(103, 110, 115);
`;
